/**
 * @module builder
 */

import type { OptionsDocument, QuoteDocument } from 'paintscout'
import { bulkOperateSubstrate } from '../bulk-operate-substrate'
import { updateAreaSubstrate } from '../../area-substrates/update-area-substrate'
import { getQuoteAreaKey } from '../../util/get-quote-area-key'
import type { SubstrateOperation } from '../'
import { adjustAreaSubstrate } from '../util/adjust-area-substrate'

export function handleSubstrateOperations(args: {
  givenQuote: QuoteDocument
  options: OptionsDocument
  substrateOperations: SubstrateOperation[]
}): QuoteDocument {
  const { givenQuote, options, substrateOperations } = args
  let currentQuote = givenQuote
  substrateOperations.forEach((operation: SubstrateOperation) => {
    const newAreaSubstrate = bulkOperateSubstrate(operation)
    const quoteAreaKey = getQuoteAreaKey(currentQuote, newAreaSubstrate)
    // Adjust for type errors so we can update
    const adjustedAreaSubstrate = adjustAreaSubstrate(newAreaSubstrate)
    const updatedQuote = updateAreaSubstrate({
      quote: currentQuote,
      options,
      areaKey: quoteAreaKey,
      areaSubstrate: adjustedAreaSubstrate,
      calculate: true
    })

    currentQuote = updatedQuote
  })

  return currentQuote
}
